
// import { } from "@ant-design/icons-vue";

import { defineComponent} from "vue"

import { useRouter } from "vue-router";
import {useStore} from "vuex"
import {userDetailApi} from "@/api/common"
export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const router = useRouter()
    const store = useStore()
    const baseUrl = process.env.VUE_APP_BASE_URL
    const avatar = require("@/assets/images/avatar.svg")
    // let name = ref(null)
    //*********** definning variables end **********//
    //*********** initData start **********//
    let userInfoStr = localStorage.getItem('userInfo')
    let userInfo = null
    if(userInfoStr){
      userInfo = JSON.parse(userInfoStr)
      getUserDetail(userInfo.Id)
    }
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    function getUserDetail(id:number){
      const data = {Id:id}
      userDetailApi(data).then((res:any)=>{
        if(res&& res.state===0){
          localStorage.setItem('userInfo',JSON.stringify(res.content))
          store.commit('setUserInfo',res.content)
        }
      })
    }
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    function logout(){
      localStorage.clear()
      router.push({path:'/login'})
    }
    //*********** DOM FUN end **********//

    return {
      logout,store,baseUrl,avatar,userInfo
    }
  },
});
